import React from "react";
import CommonInfoTab from "../Common/CommonInfoTab";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";

// icons
import SupportIcon from '@mui/icons-material/Support';


class ApplicantDetailHeader extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            updatePermission: 0,
        };
    }

    async componentDidMount(){
        await this.retrieveUpdatePermission();
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'ApplicantViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                updatePermission: p
            }
        );
    }

    render() {
        return(
            <CommonInfoTab
                flat={true}
                groups={
                    [
                        {
                            title: `${this.props.applicant.last_name} ${this.props.applicant.first_name} ${this.props.applicant.patronymic}`,
                            icon: <SupportIcon/>,
                            flat: true,
                            fields: [
                                {
                                    title: 'Тип',
                                    value:  this.props.applicant.xtype_human,
                                    flat: true,
                                    xs: 6,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['xtype', ],
                                        baseUrl: 'applicant',
                                        obj: this.props.applicant,
                                        callBack: this.props.callBack,
                                    },
                                },
                                {
                                    title: 'Статус',
                                    value:  this.props.applicant.status?.title,
                                    flat: true,
                                    xs: 6,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['status', ],
                                        baseUrl: 'applicant',
                                        obj: {
                                            id: this.props.applicant.id,
                                            status: this.props.applicant.status?.id,
                                        },
                                        callBack: this.props.callBack,
                                    },
                                },
                                {
                                    title: 'Инструктор',
                                    value:  `${this.props.applicant.instructor?.last_name} ${this.props.applicant.instructor?.first_name}`,
                                    flat: true,
                                    xs: 6,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['instructor', ],
                                        baseUrl: 'applicant',
                                        obj: {
                                            id: this.props.applicant.id,
                                            instructor: this.props.applicant.instructor?.id,
                                        },
                                        callBack: this.props.callBack,
                                    },
                                },
                                {
                                    title: 'Ссылка ВКС',
                                    value:  `https://meet.multiphysics.ru/${this.props.applicant.uuid}`,
                                    flat: true,
                                    xs: 6,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                },
                            ]
                        },
                    ]
                }
            />
        )
    }
}

export default ApplicantDetailHeader